export const API_BASE_URL = "https://apitrial.memoliworks.com/";
// export const API_BASE_URL = "http://192.168.100.18:8000/";
// export const API_BASE_URL = "http://10.65.68.150:8000/";

export const STORAGE_URL = `${API_BASE_URL}storage/`;